var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-carousel',{key:_vm.carouselKey,attrs:{"height":_vm.carouselHeight}},_vm._l((_vm.banners),function(banner,index){return _c('v-carousel-item',{key:index,attrs:{"src":_vm.getResponsiveImage(banner)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }